export const formatFileSize = (sizeInBytes: number) => {
  // Convert bytes to kilobytes (KB)
  const sizeInKB = sizeInBytes / 1024;

  // If the size is less than 1 MB, return in KB
  if (sizeInKB < 1024) {
    return `${sizeInKB.toFixed(2)} KB`;
  } else {
    // Otherwise, convert KB to MB and return in MB
    const sizeInMB = sizeInKB / 1024;
    return `${sizeInMB.toFixed(2)} MB`;
  }
};
